import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import Nav from "./components/Nav";
import LeadWidgets from "./components/LeadWidgets";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Pricing from "./pages/Pricing";
import Dashboard from "./pages/Dashboard";
import Studio from "./pages/Studio";
import AdminDashboard from "./pages/AdminDashboard";
import AdminPackages from "./pages/AdminPackages";
import AdminPayments from "./pages/AdminPayments";
import AdminUsers from "./pages/AdminUsers";
import AdminLeads from "./pages/AdminLeads";
import AdminVisitors from "./pages/AdminVisitors";
import SchoolIdCard from "./pages/SchoolIdCard";
import CollegeIdCard from "./pages/CollegeIdCard";
import EmployeeIdCard from "./pages/EmployeeIdCard";
import Help from "./pages/Help";
import useVisitorTracking from "./hooks/useVisitorTracking";
import "./App.css";

function VisitorTracker() {
    useVisitorTracking();
    return null;
}

export default function App() {
    return (
        <AuthProvider>
            <HashRouter>
                <VisitorTracker />
                <Nav />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/id-card/school" element={<SchoolIdCard />} />
                    <Route
                        path="/id-card/college"
                        element={<CollegeIdCard />}
                    />
                    <Route
                        path="/id-card/employee"
                        element={<EmployeeIdCard />}
                    />
                    <Route path="/help" element={<Help />} />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/studio"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/studio/:tid"
                        element={
                            <ProtectedRoute>
                                <Studio />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/packages"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminPackages />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/payments"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminPayments />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/users"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminUsers />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/leads"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminLeads />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/visitors"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminVisitors />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="*" element={<Landing />} />
                </Routes>
                <LeadWidgets />
                <Toaster position="bottom-right" richColors />
            </HashRouter>
        </AuthProvider>
    );
}
